import React, { useState } from "react";
import { FaCopy } from "react-icons/fa";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css"; // Optional theme
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ArticleSchemaForm = () => {
  const [formData, setFormData] = useState({
    articleType: "Article",
    url: "",
    headline: "",
    imageUrl: "",
    description: "",
    authorType: "Person",
    authorName: "",
    authorUrl: "",
    publisherName: "",
    publisherLogo: "",
    datePublished: "",
    dateModified: "",
  });

  const [schema, setSchema] = useState({
    "@context": "https://schema.org",
    "@type": "Article",
    headline: "Dummy Article Headline",
    image: "https://example.com/dummy-image.jpg",
    author: {
      "@type": "Person",
      name: "John Doe",
      url: "https://example.com/author-profile",
    },
    publisher: {
      "@type": "Organization",
      name: "Dummy Publisher",
      logo: {
        "@type": "ImageObject",
        url: "https://example.com/dummy-logo.jpg",
      },
    },
    datePublished: "2025-01-01",
    dateModified: "2025-01-05",
    description: "This is a dummy description for an article schema.",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://example.com/dummy-article",
    },
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const generateSchema = () => {
    return {
      "@context": "https://schema.org",
      "@type": formData.articleType,
      headline: formData.headline || "Default Headline",
      image: formData.imageUrl || "https://example.com/default-image.jpg",
      author: {
        "@type": formData.authorType,
        name: formData.authorName || "Default Author",
        url: formData.authorUrl || "https://example.com/default-author",
      },
      publisher: {
        "@type": "Organization",
        name: formData.publisherName || "Default Publisher",
        logo: {
          "@type": "ImageObject",
          url: formData.publisherLogo || "https://example.com/default-logo.jpg",
        },
      },
      datePublished: formData.datePublished || "2025-01-01",
      dateModified: formData.dateModified || "2025-01-05",
      description: formData.description || "Default Description",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": formData.url || "https://example.com/default-article",
      },
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const updatedSchema = generateSchema();
    setSchema(updatedSchema);
    toast.success("Schema updated successfully!");
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(JSON.stringify(schema, null, 2)).then(() => {
      toast.info("JSON-LD copied to clipboard!");
    });
  };
  const deleteSchema = () => {
    setSchema({
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "Dummy Article Headline",
      "image": "https://example.com/dummy-image.jpg",
      "author": {
        "@type": "Person",
        "name": "John Doe",
        "url": "https://example.com/author-profile",
      },
      "publisher": {
        "@type": "Organization",
        "name": "Dummy Publisher",
        "logo": {
          "@type": "ImageObject",
          "url": "https://example.com/dummy-logo.jpg",
        },
      },
      "datePublished": "2025-01-01",
      "dateModified": "2025-01-05",
      "description": "This is a dummy description for an article schema.",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "https://example.com/dummy-article",
      },
    });
    toast.warning("Schema reset to dummy data!");
  };
  
  
  
  
  return (
    <div className="container  mt-5">
      <ToastContainer />
      <h3 className="text-center mb-4">Article Schema Generator</h3>
      <div className="row">
        {/* Form Section */}
        <div className="col-lg-6 mb-4">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Enter Article Details</h5>
            <form onSubmit={handleSubmit}>
              {/* Article Type and URL */}
              <div className="row g-3">
                <div className="col-md-4">
                 
              <div className="mb-3 w-100">
                <label className="form-label">Article Type</label>
                <select
                  name="articleType"
                  className="form-select"
                  value={formData.articleType}
                  onChange={handleInputChange}
                >
                  <option value="Article">Article</option>
                  <option value="NewsArticle">News Article</option>
                  <option value="BlogPosting">Blog Posting</option>
                </select>
              </div>
                </div>
                <div className="col-md-8">
             
                <div className="mb-3">
                <label className="form-label">URL</label>
                <input
                  type="text"
                  className="form-control"
                  name="url"
                  value={formData.url}
                  onChange={handleInputChange}
                  placeholder="Enter URL"
                />
              </div>

                </div>
                </div>
             



              {/* Headline and Image */}
              <div className="mb-3">
                <label className="form-label">Headline</label>
                <input
                  type="text"
                  className="form-control"
                  name="headline"
                  value={formData.headline}
                  onChange={handleInputChange}
                  placeholder="Enter headline"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Image URL</label>
                <input
                  type="text"
                  className="form-control"
                  name="imageUrl"
                  value={formData.imageUrl}
                  onChange={handleInputChange}
                  placeholder="Enter image URL"
                />
              </div>

              {/* Description */}
              <div className="mb-3">
                <label className="form-label">Short Description</label>
                <textarea
                  className="form-control"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Enter description"
                  rows="3"
                ></textarea>
              </div>

              {/* Author Details */}
              <h6 className="mt-4">Author Details</h6>
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">Author Type</label>
                  <select
                    name="authorType"
                    className="form-select"
                    value={formData.authorType}
                    onChange={handleInputChange}
                  >
                    <option value="Person">Person</option>
                    <option value="Organization">Organization</option>
                  </select>
                </div>
                <div className="col-md-4">
                  <label className="form-label">Author Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="authorName"
                    value={formData.authorName}
                    onChange={handleInputChange}
                    placeholder="Enter author name"
                  />
                </div>
                <div className="col-md-4">
                  <label className="form-label">Author URL</label>
                  <input
                    type="text"
                    className="form-control"
                    name="authorUrl"
                    value={formData.authorUrl}
                    onChange={handleInputChange}
                    placeholder="Enter author URL"
                  />
                </div>
              </div>

              {/* Publisher Details */}
              <h6 className="mt-4">Publisher Details</h6>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Publisher Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="publisherName"
                    value={formData.publisherName}
                    onChange={handleInputChange}
                    placeholder="Enter publisher name"
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Publisher Logo URL</label>
                  <input
                    type="text"
                    className="form-control"
                    name="publisherLogo"
                    value={formData.publisherLogo}
                    onChange={handleInputChange}
                    placeholder="Enter publisher logo URL"
                  />
                </div>
              </div>

              {/* Date Published and Modified */}
              <div className="row g-3 mt-4">
                <div className="col-md-6">
                  <label className="form-label">Date Published</label>
                  <input
                    type="date"
                    className="form-control"
                    name="datePublished"
                    value={formData.datePublished}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Date Modified</label>
                  <input
                    type="date"
                    className="form-control"
                    name="dateModified"
                    value={formData.dateModified}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div className="mt-4 text-center">
                <button type="submit" className="btn btn-primary w-100">
                  Generate Schema
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* JSON-LD Preview Section */}
        <div className="col-md-6">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Generated JSON-LD</h5>
           
            <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
  <button className="btn btn-primary me-2" onClick={copyToClipboard}>
    Copy
  </button>
  <button className="btn btn-danger me-2" onClick={deleteSchema}>
    Reset
  </button>
  <button className="btn btn-info me-2">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://developers.google.com/search/docs/appearance/structured-data"
    >
      Validate
    </a>
  </button>
  <button className="btn btn-success">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://search.google.com/test/rich-results"
    >
      Test
    </a>
  </button>
</div>


               
            {schema ? (
              <div className="position-relative">
                <JSONPretty
                  id="json-pretty"
                  data={schema}
                  className="bg-light p-3 rounded border"
                ></JSONPretty>
                
              </div>
            ) : (
              <p className="text-center">No schema generated yet.</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArticleSchemaForm;
